import { PaginateTotal, adicionaZero, dateCustom } from '../../../components';
import { capitalize, cicloIntervalo, downloadArchive, numberZero, paramsApi } from '../../../helpers';
import api from '../../../helpers/api';
import apiOld from '../../../helpers/apiOld';
import apiV3 from '../../../helpers/apiV3';
import { setFiltered, setInfoCategoria, setInfoEmpresa, setListarCategorias, loaded, loading } from '../../../layout/redux/layoutActions';
import { nomesMeses } from '../../../layout/redux/layoutReducer';

const  generateDataName = (name, yrange) => {
    let y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
    return { x: name, y: y };
}
const nLojas = 7
const pagina = { 
  pageNumber: 1, 
  totalPages: 1, 
  totalElements: 0,
  perPage: 7
}

const listasMock = {
  data: Array(nLojas).fill().map((_, i)=> ({id: i+1, loja: `Loja ${i+1}`, comentario: i+1})),
  paginate: {...pagina, totalElements: nLojas, totalPages: PaginateTotal({total: nLojas, totalPerPage: pagina.perPage }) }
}

export const setInfoTotalAvaliacao = payload => ({
  type: 'COMENTARIOS_TOTAL_AVALIACAO',
  payload
})

export const setFiltersProvisorio = payload => ({
  type: 'INFO_FILTERS_COMENTARIOS',
  payload
})

export const putFiltersProvisorio = payload => ({
  type: 'CHANGE_FILTERS_COMENTARIOS',
  payload
})

export const cleanFiltersProvisorio = () => ({
  type: 'CLEAN_FILTERS_COMENTARIOS',
})


export const setListaComentarios = payload => ({
  type: 'LIST_COMENTARIOS',
  payload
})

export const setPaginateComentarios = payload => ({
  type: 'PAGINATE_COMENTARIOS',
  payload
})

export const setLoadList = payload => ({
  type: 'LOAD_LIST_COMENTARIOS',
  payload
})

export const setErroComentarioApi = payload => ({
  type: 'ERRO_COMENTARIO',
  payload
})

export const listSobreComentario = payload => ({
  type: 'LIST_SOBRECOMENTARIOS',
  payload
})

export const setSobreComentario = payload => ({
  type: 'CHANGE_SOBRECOMENTARIO',
  payload
})

// export const listarComentarios = e => {
//   return dispatch => dispatch([
//     setListaComentarios(listasMock.data),
//     setPaginateComentarios(listasMock.paginate)
//   ])
// }

// export const filterHandle = ({projetoID, params, filterActive, typeSelect, paginate}) => {
//   return dispatch => dispatch([
//     setFiltered(params),
//     setInfoEmpresa(params.empresa),
//     setInfoCategoria(params.categoria),
//     listarComentarios(),
//   ])
// }

export const filtersCustom = ({filters, typeSelect}) => {
  let paramsFilter = {}
  const dataAtual = new Date()
  if (typeSelect?.id === 'Ciclo') {
    if (filters?.ciclo?.mesAno) {
      paramsFilter = {
        intervalo: `${filters.ciclo.anoMes}`,
      }
    }
  }
  if (typeSelect?.id === 'Data') {
    paramsFilter = {
      intervalo: `${dateCustom(filters.dataInicial).data} ${dateCustom(filters.dataFinal).data}`,
    }
  }
  if (filters?.empresa?.empresaId) {
    paramsFilter = {
      ...paramsFilter,
      empresaId: filters.empresa.empresaId,
    }
  }
  if (filters?.categoria?.id) {
    paramsFilter = {
      ...paramsFilter,
      categoriaId: filters.categoria.id,
    }
  }
  return paramsFilter
}

export const listarComentarios = ({
  projetoID, 
  grupo,
  filters={}, 
  typeSelect={}, 
  idioma1,
  tipo,
  paginate = {pageNumber: 1, perPage: 7}
}) => {
  
  return dispatch => {
    dispatch(setLoadList(true))

    let params = paramsApi({
      projetoId: projetoID,
      paginaAtual: paginate.pageNumber?paginate.pageNumber:1,
      RPP: paginate.perPage?paginate.perPage:7,
      //grupo: grupo.nomeGrupo,
      ...filters,
      //empresaId:1,
      //tipo:"lojas",
      tipo:tipo,
      idioma:idioma1,

    })

    //console.error(paginate.pageNumber, 'PAGINA ATUAL');
    //apiOld.get(`/Front/GetComentarios${params}`)
    dispatch(loading())
    apiV3.get(`/Front/GetComentariosTudo${params}`)
    .then(result => {
      const initialStatePaginate = { 
        //pageNumber: paginate.pageNumber?paginate.pageNumber:1, 
        pageNumber: paginate.pageNumber?paginate.pageNumber:1,
        totalPages: result.data.totalPaginas,  
        totalElements: result.data.totalRegistros, 
        perPage: result.data.rpp
      }
      dispatch([
        //setListaComentarios(result.data.comentarioLoja),
        //setListaComentarios(result.data.comentarioProduto),
        setListaComentarios(tipo === "lojas" ? result.data.comentarioLoja : tipo === "produtos" ? result.data.comentarioProduto : result.data.comentarioRede),
        setPaginateComentarios(initialStatePaginate),
        setInfoTotalAvaliacao(result.data.qtdeAvaliacoes),
        // setListarCategorias(result.data.listaCategorias),
        setLoadList(false),
        setErroComentarioApi(false)

      ])
    })
    .catch(err => {
        console.error(err);
        const initialStatePaginate = { 
          pageNumber: 1, 
          totalPages: 1,  
          totalElements: 0, 
          perPage: paginate.perPage
        }
        dispatch([
          setListaComentarios([]),
          setPaginateComentarios(initialStatePaginate),
          setInfoTotalAvaliacao(0),
          setLoadList(false),
          setErroComentarioApi(true)
        ])
    })
    .finally(()=> {
      dispatch(loaded())
    })
  }
}

export const filterHandle = ({
  projetoID, 
  grupo,
  params, 
  filtersProvisorio, 
  typeSelect, 
  paginate,
  idioma,
  tipo

}) => {
  const paramsCustom = {...params, ciclo: params?.ciclo?.ano ? params.ciclo : filtersProvisorio.ciclo}
  const idioma1 = idioma;
  let paramsFilter = filtersCustom({filters: paramsCustom, typeSelect})
  
  
  return dispatch => {
    dispatch(setFiltered(paramsCustom))

    // Prepare the arguments for listarComentarios
    const listarComentariosArgs = {
      projetoID,
      grupo,
      filters: paramsFilter,
      typeSelect,
      idioma1,
      tipo,
      ...(paginate ? { paginate } : {}) // Conditionally add paginate
    };

    dispatch(listarComentarios(listarComentariosArgs))
  }
}

export const downloadComentarios = (e) => {
  const {
    projetoId, 
    grupo,
    params, 
    filtersProvisorio, 
    typeSelect, 
    paginate,
    idioma,
    tipo
  
  } = e
  console.error(e, 'downloadComentarios');
  const paramsCustom = {...params, ciclo: params?.ciclo?.ano ? params.ciclo : filtersProvisorio.ciclo}
  let paramsFilter = filtersCustom({filters: paramsCustom, typeSelect})

  const paramsUrl = paramsApi({
    projetoId: projetoId,
    //grupo: grupo.nomeGrupo,
    ...paramsFilter,
    //empresaId:1,
    //tipo:"lojas",
    tipo: tipo,
    idioma: idioma,
  })
    
  return dispatch => {
    //apiV3.post(`/Front/GetComentariosTudoExport${paramsUrl}`)
    dispatch(loading())
    apiV3.post(`/Front/GetComentariosTudoExportCsv${paramsUrl}`, {}, {
      responseType: 'blob'  // 🚀 Aqui está a correção!
    })
    .then(result => {
      console.error(result, 'result downloadComentarios');
      const archiveBlob = new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const archive = window.URL.createObjectURL(archiveBlob)
      downloadArchive({archive, name: 'Feedbacks', extension: 'csv'})
      setTimeout(() => window.URL.revokeObjectURL(archive), 100); //Inserir essa linha para liberar memória
    })
    .catch(err => {
      console.error(err, 'err downloadComentarios');
      
    })
    .finally(()=> {
      dispatch(loaded())
    })
  }
}